import React from "react";
import styled from "styled-components";
import SideMenu from "./SideMenu";
import Footer from "../Common/Footer";
import Nav from "../Common/Nav";
import Information from "../Common/Information";
import RequireLogin from "../../permissions.js/RequireLogin";

function FAQ() {
  return (
    <>
      <Nav />
      <Container>
        <TopSection>
          <NavigationInformation>
            Home &gt; My Profile &gt; FQA
          </NavigationInformation>
          <Title>FAQ</Title>
        </TopSection>
        <BottomSection>
          <SideMenu />
          <PageInfo>
            <Information header="Question 1" />
            <Information header="Question 2" />
            <Information header="Question 3" />
            <Information header="Question 4" />
          </PageInfo>
        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  padding: 0px 5vw;
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const NavigationInformation = styled.div`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;
  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  gap: 30px;
`;

const PageInfoTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 80% */
`;

const PageInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  height: 100%;
  border-radius: 20px;
`;

const Body = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 150% */
`;

export default RequireLogin(FAQ);
